const INLINE_IMAGE_PATTERN = /^data:image\/(jpeg|jpg|png);base64,/
const IMAGE_KEY_PREFIX = 'dedupedImage'

const isObject = (value) => value !== null && typeof value === 'object'

const isInlineImage = (image) => typeof image === 'string' && INLINE_IMAGE_PATTERN.test(image)

const createImageDeduplicator = (images) => {
  let imageIndex = 0
  const imageKeys = Object.keys(images).reduce((result, key) => {
    if (isInlineImage(images[key])) result[images[key]] = key
    return result
  }, {})

  const getNextImageKey = () => {
    do {
      imageIndex += 1
    } while (images[`${IMAGE_KEY_PREFIX}${imageIndex}`])

    return `${IMAGE_KEY_PREFIX}${imageIndex}`
  }

  const getImageKey = (image) => {
    if (!imageKeys[image]) {
      imageKeys[image] = getNextImageKey()
      images[imageKeys[image]] = image
    }

    return imageKeys[image]
  }

  return (node) => deduplicateImageNode(node, getImageKey)
}

const deduplicateImageNode = (node, getImageKey) => {
  if (Array.isArray(node)) return node.map((item) => deduplicateImageNode(item, getImageKey))
  if (!isObject(node)) return node

  if (isInlineImage(node.image)) {
    node.image = getImageKey(node.image)
  }

  Object.keys(node).forEach((key) => {
    if (typeof node[key] !== 'function') {
      node[key] = deduplicateImageNode(node[key], getImageKey)
    }
  })

  return node
}

const wrapNodeFactory = (nodeFactory, deduplicate) =>
  function(...args) {
    return deduplicate(nodeFactory.apply(this, args))
  }

const deduplicateNodeOrFactory = (nodeOrFactory, deduplicate) => {
  if (typeof nodeOrFactory === 'function') return wrapNodeFactory(nodeOrFactory, deduplicate)
  return deduplicate(nodeOrFactory)
}

export const deduplicatePdfImages = (docDefinition) => {
  const images = docDefinition.images || {}
  const deduplicate = createImageDeduplicator(images)

  docDefinition.images = images
  docDefinition.content = deduplicate(docDefinition.content)
  ;['header', 'footer', 'background', 'watermark'].forEach((key) => {
    if (docDefinition[key]) {
      docDefinition[key] = deduplicateNodeOrFactory(docDefinition[key], deduplicate)
    }
  })

  return docDefinition
}
